var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcludedFromAccountingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "85.000000pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 76.000000 85.000000",
    width: "76.000000pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "none",
    transform: "translate(0.000000,85.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 642 c0 -22 480 -502 503 -502 31 0 18 35 -33 85 l-50 49 0 120 0 119 23 -21 c27 -26 47 -28 47 -6 0 23 -72 113 -90 113 -18 0 -90 -90 -90 -113 0 -23 29 -20 51 7 18 22 18 21 19 -82 l0 -104 -55 59 c-47 51 -54 64 -55 101 0 82 -39 133 -99 133 -20 0 -42 -4 -50 -9 -9 -6 -24 3 -48 30 -37 41 -73 52 -73 21z m202 -99 c16 -19 33 -73 22 -73 -7 0 -84 78 -84 85 0 13 49 3 62 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 395 l3 -105 -35 -44 c-20 -23 -36 -50 -36 -60 0 -29 37 -18 60 19 12 19 25 35 28 35 4 0 18 -16 31 -35 24 -36 61 -47 61 -19 0 9 -16 35 -35 58 -34 42 -35 46 -35 127 -1 67 -4 89 -19 107 -11 12 -21 22 -23 22 -1 0 -2 -47 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 305 c0 -95 70 -157 145 -129 15 6 15 8 -1 25 -9 10 -22 15 -30 12 -24 -9 -64 25 -64 55 -1 24 -29 72 -44 72 -3 0 -6 -16 -6 -35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludedFromAccountingIcon);
export default __webpack_public_path__ + "static/media/ExcludedFromAccountingIcon.bd40a7edda9ac8e600c6d0b6be85adc6.svg";
export { ForwardRef as ReactComponent };